const INDEX_ITEMS = [
  {
    id: 1,
    title: '影视剧集',
    icon: 'ri-movie-2-line',
    color: 'bg-primary-100 text-primary-600',
    items: ['动作大片', '爱情甜宠', '悬疑推理', '喜剧剧场', '科幻奇幻', '古装历史'],
  },
  {
    id: 2,
    title: '综艺娱乐',
    icon: 'ri-tv-2-line',
    color: 'bg-accent-100 text-accent-600',
    items: ['真人秀', '脱口秀', '音乐竞演', '美食探店', '旅行综艺', '生活观察'],
  },
  {
    id: 3,
    title: '动漫专区',
    icon: 'ri-emotion-line',
    color: 'bg-secondary-100 text-secondary-600',
    items: ['热血战斗', '治愈日常', '异世界', '恋爱喜剧', '悬疑推理', '新番速递'],
  },
  {
    id: 4,
    title: '纪录片库',
    icon: 'ri-earth-line',
    color: 'bg-accent-100 text-accent-600',
    items: ['自然生态', '人文历史', '科技探索', '美食文化', '社会观察', '宇宙天文'],
  },
  {
    id: 5,
    title: '短视频集',
    icon: 'ri-vidicon-line',
    color: 'bg-primary-100 text-primary-600',
    items: ['创意短片', '生活Vlog', '知识科普', '搞笑段子', '音乐舞蹈', '手工教程'],
  },
  {
    id: 6,
    title: '平台导航',
    icon: 'ri-compass-3-line',
    color: 'bg-secondary-100 text-secondary-600',
    items: ['香蕉视频', '西瓜视频免费', '蜜桃视频', '樱花视频', '水果视频在线', '植物视频平台'],
  },
  {
    id: 7,
    title: '特色专题',
    icon: 'ri-star-line',
    color: 'bg-primary-100 text-primary-600',
    items: ['编辑严选', '本周最热', '评分最高', '最新上线', '限免专区', '经典重温'],
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
            主题索引
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            探索向日葵视频收录的全部水果视频在线平台内容分类
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {INDEX_ITEMS.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-xl p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer group"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center ${item.color}`}>
                  <i className={`${item.icon} text-sm`}></i>
                </div>
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
              <div className="flex flex-wrap gap-1.5">
                {item.items.map((sub, idx) => (
                  <span
                    key={idx}
                    className="px-2.5 py-1 rounded-md bg-background-50 text-xs text-foreground-600 hover:bg-primary-50 hover:text-primary-700 transition-colors whitespace-nowrap"
                  >
                    {sub}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}